import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 5v14l-12 -7z","key":"svg-0"}],["path",{"d":"M4 5l0 14","key":"svg-1"}]]

const IconPlayerSkipBack = createReactComponent('outline', 'player-skip-back', 'PlayerSkipBack', __iconNode);

export default IconPlayerSkipBack;